import { render, staticRenderFns } from "./MyDraftsMdPage.vue?vue&type=template&id=482fa7bb&scoped=true&"
import script from "./MyDraftsMdPage.vue?vue&type=script&lang=js&"
export * from "./MyDraftsMdPage.vue?vue&type=script&lang=js&"
import style0 from "./MyDraftsMdPage.vue?vue&type=style&index=0&id=482fa7bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fa7bb",
  null
  
)

export default component.exports